<div>
  <mat-error
    *ngIf="(!control.pristine || isFormSubmitted) && control.errors"
    class="dropdown-error"
    [control]="control"
  ></mat-error>
  <div *ngIf="!(!control.pristine || isFormSubmitted) || !control.errors" class="no-error-placeholder"></div>
</div>
